import { render } from "./prev-arrow.svg.vue?vue&type=template&id=00347681"
import script from "./prev-arrow.svg.vue?vue&type=script&lang=js"
export * from "./prev-arrow.svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__